import styled from 'styled-components';

export const ActionColumnWrapper = styled.div`
	display: flex;
	justify-content: space-evenly;
`;

// More than 4 action menu items are invalid and should use menu instead
export const COLUMN_WIDTH_ONE_ITEM = 50;
export const COLUMN_WIDTH_TWO_ITEMS = 100;
export const COLUMN_WIDTH_THREE_ITEMS = 150;
export const COLUMN_WIDTH_FOUR_ITEMS = 200;
